import mortgageIcon from "../images/mortgage-icon.png";
import studentLoanIcon from "../images/student-loan-icon.png";

export const mortgagePopup = {
  modalType: "popup",
  heading: "Trying to make a mortgage payment?",
  message:
    "We can't accept mortgage payments here but you're just a step away from where you need to go.",
  buttonUrl: "https://mortgagecenter.estatusconnect.com/index.html#/home/login",
  buttonText: "Go to Mortgage Payments",
  icon: mortgageIcon
};

export const studentLoanPopup = {
  modalType: "popup",
  heading: "Trying to pay your student loans?",
  message:
    "We can't accept student loan payments here but you're just a step away from where you need to go.",
  buttonUrl: "http://laketrust.studentchoice.org/Pay-Your-Loans/",
  buttonText: "Pay My Student Loans",
  icon: studentLoanIcon
};

export const cancelPopup = {
  modalType: "popup",
  heading: null,
  message: "Are you sure you would like to cancel this payment?",
  buttonUrl: null,
  buttonText: "Yes",
  button2Text: "No"
};

export const doublePaymentConfirmationPopup = {
  modalType: "confirmation",
  message: "There has already been a payment on this loan within the last 24 hours, are you sure you would like to proceed?",
};

export const scheduledAchPaymentConfirmationPopup = {
  modalType: "confirmation",
  message: "There is already a payment pending on this account. Are you sure you would like to proceed?",
};



// WEBPACK FOOTER //
// ./src/utils/popupModals.js